/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_Professionalcriteriadescription12Inputs */

const en_welcome_accreditation_professionalcriteriadescription12 = /** @type {(inputs: Welcome_Accreditation_Professionalcriteriadescription12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investment professionals in good standing holding the general securities representative license (Series 7), the investment adviser representative license (Series 65), or the private securities offerings representative license (Series 82)`)
};

/**
* | output |
* | --- |
* | "Investment professionals in good standing holding the general securities representative license (Series 7), the investment adviser representative license (Se..." |
*
* @param {Welcome_Accreditation_Professionalcriteriadescription12Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_accreditation_professionalcriteriadescription12 = /** @type {((inputs?: Welcome_Accreditation_Professionalcriteriadescription12Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_Professionalcriteriadescription12Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_professionalcriteriadescription12(inputs)
});
export { welcome_accreditation_professionalcriteriadescription12 as "welcome_accreditation_professionalCriteriaDescription1" }